import { computed } from 'mobx';
import { HeatEventRepresentation } from '../representations/HeatEventRepresentation';
import { AnimalEventCommon } from './AnimalEventCommon';
import { DialogueDisplayProps } from './DialogueDisplayProps';

export class HeatEvent extends AnimalEventCommon<HeatEventRepresentation> {
	@computed
	get displayProperties(): DialogueDisplayProps {
		return {
			occurred: this.dateOfOnFarmEventFormatted,
		};
	}
}
